export default "__VITE_ASSET__DjOUzLq8__"